var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getFetchWrapper } from '@syf-api-library/core';
import { useQuery } from '@tanstack/react-query';
import useConfig from '../../context/config.context';
export const cardEligibilityEndpoint = 'v1/credit/cards/replace';
const useCardEligibilityQuery = () => {
    const { config, accountId } = useConfig();
    const { hosts: { apigee } } = config;
    const fetchWrapper = getFetchWrapper(config);
    return useQuery({
        queryKey: [cardEligibilityEndpoint],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            return fetchWrapper(`${apigee}${cardEligibilityEndpoint}?cipher.accountId=${accountId}&accountIdType=guid`, {
                method: 'GET',
                headers: {
                    'Accept-language': ((_a = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('language')) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || ''
                }
            });
        })
    });
};
export default useCardEligibilityQuery;
//# sourceMappingURL=index.js.map